import { IconProps, SvgIcon } from 'modules/miles/shared/components/Icon/SvgIcon';
import React from 'react';

const BurgerMenuPath = (
  <path fillRule='evenodd' clipRule='evenodd' d='M22 7.5H2V4.5H22V7.5ZM22 14H2V11H22V14ZM2 20.5H22V17.5H2V20.5Z' fill='currentColor' />
);

export const BurgerMenu = (props: IconProps) => <SvgIcon path={BurgerMenuPath} {...props} />;
